import React from 'react';

var QuickLinkIcon = function QuickLinkIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, React.createElement("g", {
    fill: "#121111"
  }, React.createElement("path", {
    d: "M24.944.922a.15.15 0 01-.055-.102c-.054-.103-.054-.154-.109-.205V.512l-.436-.41h-.109L24.017 0H13.173c-.584 0-1.123.293-1.415.769a1.456 1.456 0 000 1.537c.292.475.831.768 1.415.768h6.267l-7.247 6.66a1.44 1.44 0 00-.49 1.075c0 .407.176.796.49 1.076.301.29.713.455 1.144.461.435.013.854-.155 1.144-.46l7.248-6.814v5.891c0 .549.312 1.056.817 1.33a1.724 1.724 0 001.635 0c.506-.274.817-.78.817-1.33v-9.58a.63.63 0 00-.054-.307V.922z"
  }), React.createElement("path", {
    d: "M19.015 21.892H3.101v-15.9H8.32V2.886H1.55A1.502 1.502 0 000 4.439v19.008A1.502 1.502 0 001.55 25h19.015a1.549 1.549 0 001.55-1.553V16.66h-3.1v5.231z"
  })));
};

export default QuickLinkIcon;